import React from "react";

const BloodClinicalModule = React.lazy(() => import("./ui/BloodClinical"));

export const BloodClinicalPage = () => {
  return <BloodClinicalModule />;
};
